// extracted by mini-css-extract-plugin
export default {"checkboxItem":"styles_checkboxItem__6ZC-Z","block":"styles_block__SFLt-"};